//Show Hide Password
$(".show_hide_password a").on('click', function(event) {
    event.preventDefault();
    if($(this).closest ('.show_hide_password').find('input').attr("type") == "text"){
        $(this).closest ('.show_hide_password').find('input').attr('type', 'password');
        $(this).closest ('.show_hide_password').find('i').addClass( "fa-eye-slash" );
        $(this).closest ('.show_hide_password').find('i').removeClass( "fa-eye" );
    }else if($(this).closest ('.show_hide_password').find('input').attr("type") == "password"){
        $(this).closest ('.show_hide_password').find('input').attr('type', 'text');
        $(this).closest ('.show_hide_password').find('i').removeClass( "fa-eye-slash" );
        $(this).closest ('.show_hide_password').find('i').addClass( "fa-eye" );
    }
});
//END Show Hide Password

//Get Contact URL
window.getURL = function () {
    //whatsapp
    var waNumber = $('a#whatsappURL').attr('data-value');
    var waURL = 'https://wa.me/' + waNumber;

    $("a#whatsappURL").attr("href", waURL);

    //skype
    var skype = $('#skypeNumber').text();
    var skypeURL = 'skype:' + skype + '?chat';

    $("a#skypeURL").attr("href", "");

    var _href = $("a#skypeURL").attr("href");
    $("a#skypeURL").attr("href", _href + skypeURL);

    //mobile call
    var call = $('#callNumber').text();
    var callURL = 'tel:' + call;

    $("a#callURL").attr("href", "");

    var _href = $("a#callURL").attr("href");
    $("a#callURL").attr("href", _href + callURL);

    //Telegram
    set_telegram('.footer-section #telegramURL');
    set_telegram('.footer-section #telegram2URL');

    // Zalo
    var zaloNum = $('#zaloNumber').text();
    var trimZaloNumber = $.trim(zaloNum);
    var zaloURL = 'https://zalo.me/' + trimZaloNumber;

    $("a#zaloURL").attr("href", "");
    var _href = $("a#zaloURL").attr("href");
    $("a#zaloURL").attr("href", _href + zaloURL);

    //viber
    var viberNum = $('#zaloNumber').text();
    var viberNumber = $.trim(viberNum);
    var viberURL = 'viber://chat?number=' + viberNumber;

    $("a#viberURL").attr("href", "");
    var _href = $("a#viberURL").attr("href");
    $("a#viberURL").attr("href", _href + viberURL);
}
window.set_telegram = function (telegram_link) {
    var telegram = $(telegram_link).data('value');
    var telegramNumber = $.trim(telegram);
    var telegramURL = 'http://t.me/' + telegramNumber;

    $(telegram_link).attr("href", "");

    var _href = $(telegram_link).attr("href");
    $(telegram_link).attr("href", _href + telegramURL);
}
//END Get Contact URL

$(window).on('load', function() {
    //Hide at AppView
    if (window.location.href.indexOf("?=appview") > -1) {
        $('.top-nav-mobile').addClass('hidden');
        $('.nav-desktop').addClass('hidden');
        $('.app-notify').addClass('d-none');
        $('.nav-mobile').addClass('hidden');
        $('.page-content').addClass('appview');
        $('footer').addClass('hidden');
        $('#bottomMenu').addClass('hidden');
        $('#floating-banner-container').addClass('hidden');
        $('#liveChat').addClass('hidden');
        $('#chat-widget-container').addClass('hidden');
        $('#main').addClass('appview');
        $('#floatContact').addClass('hidden');
        $('.idx-announcement').addClass('hidden');
        $('#chatScroll').addClass('hidden');
        $('.aside-event').addClass('hidden');
        $('.bottom-menu-wrapper').addClass('hidden');
        $('.webview-class').addClass('hidden');
    }

    setTimeout(function() {
        $('#pageLoader').addClass('d-none');
    }, 1500)
});

//Line Auth
$('.lineLoginBtn, .bottomLineIcon').on('click', function(e) {
    let country = window.runtime_en;
    let protocal = $(location).attr('protocol');  
    let hostname =  $(location).attr('hostname'); 
    let client_id = window.countryChannelId;
    
    let redirect_uri = '';
    if (country == 'en'){
        redirect_uri = protocal +'//'+hostname+'/'+country+'/line-auth-callback';
    }else{
        redirect_uri = protocal +'//'+hostname+'/line-auth-callback';
    }

    // let redirect_uri = 'https://77bet-thb.test/line-auth-callback';
    let link = 'https://access.line.me/oauth2/v2.1/authorize?';
    link += 'response_type=code';
    link += '&client_id=' + client_id;
    link += '&redirect_uri=' + redirect_uri;
    link += '&state=login';
    // bot_prompt => to add friend request
    link += '&bot_prompt=aggressive';
    link += '&scope=openid%20profile%20email';

    window.location.href = link;
});

//Sweetalert Login & Register
window.promptLoginRegister = function () {
    
    Swal.fire({
        title:window.auth_proceed,
        icon: 'info',
        showDenyButton: true,
        confirmButtonText: window.auth_login_now,
        denyButtonText: window.auth_jois_us,
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            location.href = window.auth_login_url;
        } else if (result.isDenied) {
            location.href = window.auth_register_url;
        }
    })
};

//LazyLaod
var lazyLoadInstance = new LazyLoad({
    elements_selector: "img, .lazy",
    load_delay: 100,
});

//Bootstrap tooltip
$(function () {
    $('[data-toggle="tooltip"]').tooltip()
});

// Toggle hidden value into text
$('.toggleInputType').click(function()
{
    $(this).toggleClass('fa-eye-slash').toggleClass('fa-eye');
    
    if( $(this).siblings('input').attr('type') === "password"  )
        $(this).siblings('input').attr('type', 'text');
    else
        $(this).siblings('input').attr('type', 'password');
});